import { render, staticRenderFns } from "./OptionCreateForm.vue?vue&type=template&id=455d4ca9"
import script from "./OptionCreateForm.vue?vue&type=script&lang=js"
export * from "./OptionCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports